import React from 'react'
import Header from '../Header'
import Sciencebanner from '../academics/Sciencebanner'
import Footer from '../Footer'
import Career from './Career'
import AcademicsPage from './AcademicsPage'
import Subjects from './Subjects'

const Academics = () => {
  return (
    <div>
      <Header/>
      <Sciencebanner/>
      <AcademicsPage/>
      <Subjects/>
      <Career/>
      <Footer/>
    </div>
  )
}

export default Academics